function prepSlideSvg(slideEl) {
    const paths = slideEl.querySelectorAll(
        ".no-main-hero__object path, .no-main-hero__object circle, .no-main-hero__object polyline, .no-main-hero__object line"
    );
    paths.forEach((p) => {
        // getTotalLength는 path/line/polyline/circle 모두 지원 (circle은 근사치)
        const len =
            typeof p.getTotalLength === "function" ? p.getTotalLength() : 0;
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
        p.dataset._dash = len; // 캐시
    });
}

function seedObjectTransforms() {
    const slides = document.querySelectorAll("#main-hero-swiper .swiper-slide");

    slides.forEach((slide, i) => {
        const svg = slide.querySelector(".no-main-hero__object svg");
        if (!svg) return;

        // 랜덤 값들(범위는 취향대로 조정)
        const rot = gsap.utils.random(-12, 12, true)(); // 회전 각도
        const scl = gsap.utils.random(1.58, 1.72, true)(); // 스케일
        const dx = gsap.utils.random(-48, 48, true)(); // px 이동 X
        const dy = gsap.utils.random(-32, 32, true)(); // px 이동 Y

        gsap.set(svg, {
            // 기존 CSS: translate(-70%, -50%) scale(1.65) 를 GSAP로 재현 + 랜덤치
            xPercent: -70,
            yPercent: -50,
            scale: scl,
            rotation: rot,
            x: dx,
            y: dy,
            transformOrigin: "50% 50%",
        });
    });
}

// --- [NEW] 슬라이드별 SVG Wiggle(지속 모션) 관리 ---
const _wiggles = new WeakMap();

function ensureWiggle(slideEl) {
    const svg = slideEl.querySelector(".no-main-hero__object svg");
    if (!svg) return null;

    // 이미 있으면 그대로 반환
    if (_wiggles.has(slideEl)) return _wiggles.get(slideEl);

    const rand = gsap.utils.random;
    // repeatRefresh:true 로 각 왕복 사이클마다 랜덤 목표값을 다시 평가
    const tween = gsap.to(svg, {
        x: () => rand(-48, 48, true)(),
        y: () => rand(-32, 32, true)(),
        rotation: () => rand(-12, 12, true)(),
        scale: () => rand(1.58, 1.72, true)(),
        duration: () => rand(3.2, 6.0, true)(),
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        repeatRefresh: true,
        paused: true, // 기본은 멈춰두고, 활성 슬라이드에서만 재생
        transformOrigin: "50% 50%",
    });

    _wiggles.set(slideEl, tween);
    return tween;
}

function playWiggleFor(activeSlide) {
    // 모든 슬라이드 멈춤
    document
        .querySelectorAll("#main-hero-swiper .swiper-slide")
        .forEach((slide) => {
            const tw = ensureWiggle(slide);
            if (tw) tw.pause();
        });

    // 활성 슬라이드만 재생
    const twActive = ensureWiggle(activeSlide);
    if (twActive) twActive.play();
}

function resetSlideSvg(slideEl) {
    const paths = slideEl.querySelectorAll(
        ".no-main-hero__object [data-_dash], .no-main-hero__object path, .no-main-hero__object circle, .no-main-hero__object polyline, .no-main-hero__object line"
    );
    paths.forEach((p) => {
        const len =
            parseFloat(p.dataset._dash) ||
            (typeof p.getTotalLength === "function" ? p.getTotalLength() : 0);
        p.style.strokeDashoffset = len;
    });
}

function drawSlideSvg(slideEl) {
    const paths = slideEl.querySelectorAll(
        ".no-main-hero__object path, .no-main-hero__object circle, .no-main-hero__object polyline, .no-main-hero__object line"
    );
    const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

    // 살짝 페이드인(선택)
    tl.fromTo(
        slideEl.querySelector(".no-main-hero__object"),
        { opacity: 0 },
        { opacity: 1, duration: 0.35 },
        0
    );

    // 경로들을 약간의 간격을 두고 순차 드로잉
    paths.forEach((p, i) => {
        const len =
            parseFloat(p.dataset._dash) ||
            (typeof p.getTotalLength === "function" ? p.getTotalLength() : 0);
        tl.fromTo(
            p,
            { strokeDashoffset: len },
            { strokeDashoffset: 0, duration: 0.9, ease: "power2.out" },
            i * 0.06 // 스태거
        );
    });

    // 반짝 하이라이트(선택: 이미지 리빌과 매칭)
    const galleryActive = document.querySelector(
        ".no-main-hero__gallery .no-main-hero__image.is-revealing"
    );
    if (galleryActive) {
        const glow = galleryActive;
        tl.fromTo(
            glow,
            { filter: "brightness(1)" },
            {
                filter: "brightness(1.06)",
                duration: 0.3,
                yoyo: true,
                repeat: 1,
            },
            0.1
        );
    }

    return tl;
}

function initMainHero() {
    console.log("initMainHero()");
    // 1) 컨테이너 명시적으로 잡기
    const el = document.getElementById("main-hero-swiper");

    if (el) {
        // 2) 갤러리 이미지 목록
        const galleryItems = document.querySelectorAll(
            ".no-main-hero__gallery .no-main-hero__image"
        );

        // 3) 현재 인덱스의 이미지만 리빌
        function revealAt(index) {
            galleryItems.forEach((el, i) => {
                if (i === index) el.classList.add("is-revealing");
                else el.classList.remove("is-revealing");
            });
        }

        document
            .querySelectorAll("#main-hero-swiper .swiper-slide")
            .forEach(prepSlideSvg);

        seedObjectTransforms();

        // 4) 스와이퍼 생성
        const swiper = new Swiper(el, {
            loop: true,
            effect: "fade",
            fadeEffect: { crossFade: true },
            speed: 1200,
            autoplay: { delay: 10000, disableOnInteraction: true },
            pagination: {
                type: "bullets",
                el: el.querySelector(".no-main-hero__pagination"),
                clickable: true,
            },
            navigation: {
                nextEl: el.querySelector(".no-main-hero__button--next"),
                prevEl: el.querySelector(".no-main-hero__button--prev"),
            },
            on: {
                // 초기 로드 시 현재 realIndex에 맞춰 갤러리 표시
                init(sw) {
                    revealAt(sw.realIndex);
                    const activeSlide = el.querySelector(
                        ".swiper-slide-active"
                    );
                    resetSlideSvg(activeSlide); // 안전 초기화
                    drawSlideSvg(activeSlide);

                    playWiggleFor(activeSlide);
                },
                // 슬라이드 바뀔 때마다 갤러리도 동기화
                slideChangeTransitionStart(sw) {
                    // 갤러리 동기화
                    revealAt(sw.realIndex);

                    // 이전/다음 모두 리셋(루프 복제 슬라이드로 인해 active만 리셋하면 잔상 가능)
                    el.querySelectorAll(".swiper-slide").forEach(resetSlideSvg);

                    // 새 활성 슬라이드 드로우
                    const activeSlide = el.querySelector(
                        ".swiper-slide-active"
                    );
                    drawSlideSvg(activeSlide);

                    playWiggleFor(activeSlide);
                },
            },
        });
    }

    const serviceSwiper = new Swiper("#main-service-swiper", {
        // loop: true,
        slidesPerView: 3,
        spaceBetween: 80,
        speed: 1200,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.25,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 60,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 80,
            },
        },
    });

    const peopleSection = document.querySelector(".no-main-team");
    const peopleSvg = document.querySelector(".no-main-team__line svg");

    if (peopleSection && peopleSvg) {
        // 1) SVG 내 그릴 대상 수집
        const elems = peopleSvg.querySelectorAll(
            "path, line, polyline, polygon, circle, ellipse, rect"
        );

        // 2) 길이 계산 + 초기 상태(안 그려진 상태) 세팅
        elems.forEach((el) => {
            let len = 0;
            if (typeof el.getTotalLength === "function") {
                len = el.getTotalLength();
            } else if (el.tagName === "rect") {
                const w = parseFloat(el.getAttribute("width")) || 0;
                const h = parseFloat(el.getAttribute("height")) || 0;
                len = 2 * (w + h);
            }
            el.dataset._dash = len; // 캐시
            gsap.set(el, {
                strokeDasharray: len,
                strokeDashoffset: len,
                // 선택: 선이 보장되도록
                // stroke: el.getAttribute('stroke') || 'currentColor'
            });
        });

        // 3) 스크롤에 따라 dashoffset을 0으로 (그려지기)
        //    한 번에 전체를 그리려면 타임라인으로 묶고, 경로마다 살짝 스태거
        const tl = gsap.timeline({
            defaults: { ease: "none" },
            scrollTrigger: {
                trigger: peopleSection,
                start: "top 80%", // 섹션 상단이 뷰포트 80% 위치에 올 때 시작
                end: "bottom bottom", // 섹션 하단이 뷰포트 40% 위치에 올 때 끝
                scrub: true, // 스크롤 연동
                // once: false         // 한 번만 재생하려면 true로
            },
        });

        elems.forEach((el, i) => {
            const len = parseFloat(el.dataset._dash) || 0;
            tl.to(el, { strokeDashoffset: 0, duration: 1 }, i * 0.08); // 살짝 순차로
        });
    }

    // horizontal scroll
    const container = document.querySelector(".no-main-interior");
    const wrapper = document.querySelector(".no-main-interior__wrapper");
    const items = [...document.querySelectorAll(".no-main-interior__item")];

    if (!wrapper || items.length === 0) return;
    const getDisance = () => {
        const totalWidth =
            wrapper.scrollWidth +
            (window.innerWidth >= 768 ? window.innerWidth / 4 : 1);
        const viewportWidth = window.innerWidth;
        const scrollDistance = totalWidth - viewportWidth;

        return scrollDistance;
    };

    gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top top",
            end: () => {
                return `+=${getDisance()}`;
            },
            scrub: true,
            pin: true,
            anticipatePin: 1,
        },
    }).to(wrapper, {
        x: -getDisance(),
        ease: "none",
        duration: 5,
    });

    // const container = document.querySelector('.no-main-interior');          // 핀될 섹션
    // const inner     = document.querySelector('.no-main-interior__inner');   // .no-container-xl
    // const wrapper   = document.querySelector('.no-main-interior__wrapper'); // 가로로 움직일 래퍼
    // if (!container || !inner || !wrapper) return;

    // let tl;

    // // 이미지 로드 보장
    // const waitImages = el => {
    //     const imgs = [...el.querySelectorAll('img')];
    //     if (!imgs.length) return Promise.resolve();
    //     return Promise.all(
    //     imgs.map(img => img.complete ? Promise.resolve()
    //                                 : new Promise(r => img.addEventListener('load', r, {once:true})))
    //     );
    // };

    // // ★ 핵심: 실제로 보여줘야 하는 마지막 X 위치를 정확히 산출
    // function measureDistance() {
    //     const last = wrapper.lastElementChild;                       // 마지막 카드(스페이서 포함)
    //     const cs   = getComputedStyle(inner);                        // 컨테이너 패딩까지 포함
    //     const padR = parseFloat(cs.paddingRight) || 0;

    //     // 마지막 요소의 "왼쪽 오프셋 + 자체 폭 + (오른쪽 패딩 보정)"
    //     // flex-gap, 내부 패딩, 마지막 스페이서 폭까지 자연스럽게 포함됨
    //     const lastRight = last ? (last.offsetLeft + last.offsetWidth + padR)
    //                         : (wrapper.scrollWidth + padR);

    //     const visibleWidth = container.clientWidth;                  // 핀되는 가시 폭
    //     return Math.max(0, Math.ceil(lastRight - visibleWidth));     // 음수 방지 + 올림
    // }

    // function build() {
    //     // 기존 TL 제거
    //     if (tl) { tl.scrollTrigger?.kill(); tl.kill(); }

    //     // 항상 최신 측정치를 사용하도록 함수형 지정
    //     tl = gsap.timeline({
    //     defaults: { ease: 'none' },
    //     scrollTrigger: {
    //         trigger: container,
    //         start: 'top top',
    //         end: () => '+=' + measureDistance(),     // 리프레시/리사이즈/이미지후에도 정확
    //         scrub: true,
    //         pin: true,
    //         anticipatePin: 1,
    //         invalidateOnRefresh: true
    //     }
    //     })
    //     .fromTo(wrapper,
    //     { x: 0 },
    //     { x: () => -measureDistance(), duration: 1 }
    //     );

    //     ScrollTrigger.refresh();                    // 강제 재측정
    // }

    // waitImages(wrapper).then(build);              // 이미지 로드 후 빌드

    // // 리사이즈에 완전 대응
    // let raf;
    // window.addEventListener('resize', () => {
    //     cancelAnimationFrame(raf);
    //     raf = requestAnimationFrame(build);
    // });
}

function initMarquee() {
    const marquee = document.querySelectorAll(".no-marquee");

    if (!marquee) return;

    marquee.forEach((item) => {
        const marqueeInner = item.querySelector(".no-marquee__inner");
        const marqueeContent = marqueeInner.querySelector(
            ".no-marquee__content"
        );

        // Duration
        const duration = item.getAttribute("data-marquee-duration");

        // Element Clone
        const marqueeContentClone = marqueeContent.cloneNode(true);
        marqueeInner.append(marqueeContentClone);

        // Marquee animation
        const marqueeContentAll = marqueeInner.querySelectorAll(
            ".no-marquee__content"
        );
        marqueeContentAll.forEach((element) => {
            gsap.to(element, {
                x: "-101%",
                repeat: -1,
                duration: duration,
                ease: "linear",
            });
        });
    });
}

function initClnicIntro() {
    const swiper = new Swiper(".thumb-swiper", {
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            0: {
                spaceBetween: 5,
                slidesPerView: 4,
            },
            768: {
                spaceBetween: 10,
                slidesPerView: 6,
            },
        },
    });
    const swiper2 = new Swiper(".control-swiper", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });
}

function initLenis() {
    const lenis = new Lenis();
    console.log(lenis);

    lenis.on("scroll", (e) => {
        ScrollTrigger.update();
    });

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
}

function initMainPofol() {
    console.log("initMainPofol()");
    const SELECTOR = "#main-pofol-swiper";

    const el = document.querySelector(SELECTOR);
    if (!el) return;

    const swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
            nextEl: ".no-main-pofol__button--next",
            prevEl: ".no-main-pofol__button--prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.5,
            },
            544: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4,
            },
        },
    });
}

function initMainResource() {
    console.log("initMainResource()");
    const SELECTOR = "#main-resource-swiper";

    const el = document.querySelector(SELECTOR);
    if (!el) return;

    const swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 24,
        breakpoints: {
            320: {
                slidesPerView: 1.5,
            },
            544: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 2.5,
            },
        },
    });
}

function initSubNav() {
    console.log("initSubNav()");
    const SELECTOR = "#sub-nav-swiper";

    const el = document.querySelector(SELECTOR);
    if (!el) return;

    const swiper = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 8,
        navigation: {
            nextEl: ".no-sub-nav__button--next",
            prevEl: ".no-sub-nav__button--prev",
        },
        on: {
            init() {
                const activeIndex = this.slides.findIndex((slide) =>
                    slide.classList.contains("--active")
                );

                if (activeIndex === -1) return;

                this.slideTo(activeIndex);
            },
        },
    });
}

function initHeader() {
    console.log("initHeader()");

    const header = document.getElementById("main-header");

    if (!header) return;

    const nav = header.querySelector(".no-header__nav");

    if (!nav) return;

    const tl = gsap.timeline({ paused: true });

    tl.to(header, {
        height: () => {
            return nav.offsetHeight + "px";
        },
        ease: "power3.inOut",
    });

    const onEnter = () => {
        header.setAttribute("aria-expanded", true);
        tl.play();
    };

    const onLeave = () => {
        header.removeAttribute("aria-expanded");
        tl.reverse();
    };

    nav.addEventListener("mouseenter", onEnter);
    header.addEventListener("mouseleave", onLeave);

    window.addEventListener("resize", (e) => {
        if (window.innerWidth <= 1024) {
            header.removeAttribute("style");
            header.removeAttribute("aria-expanded");
        }
    });

    const drawer = document.getElementById("main-drawer");
    console.log(drawer);

    if (!drawer) return;

    const drawerOpenBtn = header.querySelector(".no-header__toggle");
    const drawerCloseBtn = drawer.querySelector(".no-drawer__toggle");

    const drawerTl = gsap.timeline({ paused: true });
    drawerTl.to(drawer, {
        x: "0%",
        opacity: 1,
        ease: "power3.inOut",
    });

    const onOpen = () => {
        document.body.classList.add("--hidden");
        drawerTl.play();
    };

    const onClose = () => {
        document.body.classList.remove("--hidden");
        drawerTl.reverse();
    };

    drawerOpenBtn.addEventListener("click", onOpen);
    drawerCloseBtn.addEventListener("click", onClose);
}

function initFloatMenu() {
    const container = document.querySelector(".no-floating-container");
    const menu = document.querySelector(".no-floating-menu");
    if (!container || !menu) return;

    const PIN_OFFSET = 100; // 고정 시작 보정 (헤더 높이 등)
    const SCROLL_OFFSET = PIN_OFFSET; // 섹션 이동 시 상단 여백(고정헤더 고려)

    gsap.registerPlugin(ScrollTrigger);

    // 메뉴 고정
    ScrollTrigger.create({
        trigger: container,
        start: `top+=${PIN_OFFSET} top`,
        end: "bottom bottom",
        pin: menu,
        pinSpacing: false,
        anticipatePin: 1,
        invalidateOnRefresh: true,
    });

    // ============ Active 처리 ============

    const links = Array.from(menu.querySelectorAll(".no-floating-menu__link"));

    // href에서 해시만 뽑아 섹션 매핑
    const items = links
        .map((link) => {
            try {
                const url = new URL(link.href, location.origin);
                const hash = url.hash?.replace("#", "") || "";
                if (!hash) return null;
                const section = document.getElementById(hash);
                if (!section) return null;
                return { link, section, hash };
            } catch (e) {
                return null;
            }
        })
        .filter(Boolean);

    const clearActive = () => {
        links.forEach((a) => a.classList.remove("--active"));
    };
    const setActive = (link) => {
        if (!link) return;
        clearActive();
        link.classList.add("--active");
    };

    // 섹션별 트리거 생성 (섹션이 뷰포트 중앙에 가까울 때 활성화)
    items.forEach(({ link, section }) => {
        ScrollTrigger.create({
            trigger: section,
            start: `top+=${SCROLL_OFFSET} center`,
            end: `bottom center`,
            onEnter: () => setActive(link),
            onEnterBack: () => setActive(link),
            // 섹션 높이 변화 대응
            invalidateOnRefresh: true,
        });
    });

    // 초기 로드 시 현재 위치 기준으로 활성화 보정
    requestAnimationFrame(() => ScrollTrigger.refresh());
    // ============ 클릭 시 스무스 스크롤 ============

    const scrollToSection = (el) => {
        const top =
            el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({ top, behavior: "smooth" });
    };

    links.forEach((a) => {
        a.addEventListener("click", (e) => {
            const hash = new URL(a.href, location.origin).hash.replace("#", "");
            const target = document.getElementById(hash);
            if (target) {
                e.preventDefault();
                scrollToSection(target);
                // 즉시 시각 피드백
                setActive(a);
                history.replaceState(null, "", `#${hash}`);
            }
        });
    });

    // 이미지/폰트 등 지연 로드로 레이아웃 변할 때 재계산
    window.addEventListener("load", () => ScrollTrigger.refresh());

    setTimeout(() => {
        const currentHash = location.hash?.replace("#", "");

        if (currentHash) {
            const target = document.getElementById(currentHash);

            if (target) {
                scrollToSection(target);
                const found = items.find((i) => i.hash === currentHash);
                if (found) setActive(found.link);
            }
        }
    }, 300);
}

async function initCaptcha() {
    console.log("initCaptcha()");

    const img = document.getElementById("captcha-img");
    const refresh = document.getElementById("captcha-refresh");
    const listen = document.getElementById("captcha-listen");
    const audioEl = document.getElementById("captcha-audio");

    if (!img || !refresh || !listen || !audioEl) return;

    const listenIcon = listen.querySelector("i");
    let isPlaying = false;

    function resetAudio() {
        try {
            audioEl.pause();
        } catch (e) {}
        audioEl.removeAttribute("src");
        audioEl.load();
        isPlaying = false;
        if (listenIcon) {
            listenIcon.classList.remove("fa-volume-slash");
            listenIcon.classList.add("fa-volume");
        }
    }

    function refreshCaptcha() {
        // 오디오 재생 중이면 초기화
        resetAudio();
        // 캐시 무력화
        img.src = "/inc/lib/captcha.image.php?_=" + Date.now();
    }

    async function toggleAudio() {
        if (isPlaying) {
            // 현재 재생 중 → 멈춤
            resetAudio();
            return;
        }

        try {
            listen.disabled = true;
            const url = "/inc/lib/captcha.audio.php?_=" + Date.now();

            resetAudio(); // 혹시 모를 잔여 상태 초기화
            audioEl.src = url;

            await audioEl.play();
            isPlaying = true;

            if (listenIcon) {
                listenIcon.classList.remove("fa-volume");
                listenIcon.classList.add("fa-volume-slash");
            }

            // 재생이 끝나면 상태 원복
            audioEl.onended = () => {
                resetAudio();
            };
        } catch (err) {
            console.error(err);
            alert("오디오를 재생할 수 없습니다.");
            resetAudio();
        } finally {
            listen.disabled = false;
        }
    }

    // 초기 표시
    //   refreshCaptcha();

    // 이벤트 바인딩
    refresh.addEventListener("click", refreshCaptcha);
    listen.addEventListener("click", toggleAudio);

    // 새로고침 버튼 키보드 접근성
    refresh.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            refreshCaptcha();
        }
    });
}

function initgoToTop() {
    const root = document.getElementById("gototop"); // .no-gototop 래퍼
    const button = root?.querySelector(".no-gototop__btn");
    if (!root || !button) return;

    // 접근성 속성
    button.setAttribute("aria-label", "맨 위로 이동");
    root.setAttribute("aria-hidden", "true");

    const THRESHOLD = 200; // 몇 px 내렸을 때 보일지
    let ticking = false;

    function toggle() {
        const shouldShow = window.scrollY > THRESHOLD;
        if (shouldShow) {
            root.classList.add("is-visible");
            root.setAttribute("aria-hidden", "false");
        } else {
            root.classList.remove("is-visible");
            root.setAttribute("aria-hidden", "true");
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            toggle();
            ticking = false;
        });
    }

    // 클릭 시 스크롤 맨 위
    function scrollTopSmooth() {
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;
        window.scrollTo({
            top: 0,
            behavior: prefersReduced ? "auto" : "smooth",
        });
    }

    // 키보드 접근성 (Enter/Space)
    function onKey(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            scrollTopSmooth();
        }
    }

    // 초기 상태 & 이벤트
    toggle();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    button.addEventListener("click", scrollTopSmooth);
    button.addEventListener("keydown", onKey);
}

function initBaseFaq() {
    const lists = document.querySelectorAll(".no-faq__list");
    if (!lists.length) return;

    lists.forEach((list) => {
        const items = list.querySelectorAll(".no-faq__item");
        if (!items.length) return;

        items.forEach((item) => {
            const head = item.querySelector(".no-faq__head");
            if (!head) return;

            head.addEventListener("click", () => {
                const isActive = item.classList.contains("--active");

                // 다른 항목 닫기
                items.forEach((sibling) =>
                    sibling.classList.remove("--active")
                );

                // 현재 항목 토글
                if (!isActive) {
                    item.classList.add("--active");
                }
            });
        });
    });
}

function initBeforeAfterFaq() {
    const lists = document.querySelectorAll(".no-main-compare__items");
    if (!lists.length) return;

    lists.forEach((list) => {
        const allowMultiple =
            list.getAttribute("data-accordion") === "multiple";
        const items = Array.from(
            list.querySelectorAll(".no-main-compare__item")
        );
        if (!items.length) return;

        const collapse = (item) => {
            if (!item.classList.contains("--active")) return;
            const head = item.querySelector(".no-main-compare__head");
            const body = item.querySelector(".no-main-compare__body");
            item.classList.remove("--active");
            if (head) head.setAttribute("aria-expanded", "false");
            if (body) body.style.maxHeight = "";
        };

        const expand = (item) => {
            if (item.classList.contains("--active")) return;
            const head = item.querySelector(".no-main-compare__head");
            const body = item.querySelector(".no-main-compare__body");
            item.classList.add("--active");
            if (head) head.setAttribute("aria-expanded", "true");

            // 이미지가 늦게 로드될 수 있어 두 번 계산
            if (body) {
                body.style.maxHeight = body.scrollHeight + "px";
                // 한 프레임 뒤 재계산(이미지 onload 직후 반영용)
                requestAnimationFrame(() => {
                    body.style.maxHeight = body.scrollHeight + "px";
                });
            }
        };

        // 초기화 + 접근성
        items.forEach((item) => {
            const head = item.querySelector(".no-main-compare__head");
            const body = item.querySelector(".no-main-compare__body");
            if (!head || !body) return;

            // body id 연결
            if (!body.id)
                body.id = `ba-body-${Math.random().toString(36).slice(2)}`;
            head.setAttribute("aria-controls", body.id);
            head.setAttribute(
                "aria-expanded",
                item.classList.contains("--active") ? "true" : "false"
            );
            head.setAttribute("type", "button");

            // 활성 항목은 높이 세팅
            if (item.classList.contains("--active")) {
                body.style.maxHeight = body.scrollHeight + "px";
            } else {
                body.style.maxHeight = "";
            }

            // 클릭 토글
            head.addEventListener("click", () => {
                const isActive = item.classList.contains("--active");
                if (!allowMultiple) {
                    items.forEach((i) => {
                        if (i !== item) collapse(i);
                    });
                }
                isActive ? collapse(item) : expand(item);
            });

            // 키보드 접근성(Enter/Space)
            head.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    head.click();
                }
            });

            // 내부 이미지 로드 시 높이 재계산
            body.querySelectorAll("img").forEach((img) => {
                img.addEventListener(
                    "load",
                    () => {
                        if (item.classList.contains("--active")) {
                            body.style.maxHeight = body.scrollHeight + "px";
                        }
                    },
                    { passive: true }
                );
            });
        });

        // 리사이즈 시 열린 항목 높이 갱신
        let raf = null;
        const onResize = () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
                items.forEach((item) => {
                    if (item.classList.contains("--active")) {
                        const body = item.querySelector(
                            ".no-main-compare__body"
                        );
                        if (body)
                            body.style.maxHeight = body.scrollHeight + "px";
                    }
                });
                raf = null;
            });
        };
        window.addEventListener("resize", onResize, { passive: true });
        window.addEventListener("load", onResize);
    });
}

function app() {
    console.log("app()");

    document.addEventListener("DOMContentLoaded", () => {
        initLenis();
        initMainHero();
        initMainPofol();
        initMainResource();
        initSubNav();
        initHeader();
        initFloatMenu();
        initCaptcha();
        initgoToTop();
        initClnicIntro();
        initMarquee();
        initBaseFaq();
        initBeforeAfterFaq();

        AOS.init();
    });
}
app();
